(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 1000px)');
  var BUFFER = 20;
  var wrapper;

  function headerOffset() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    return (v && v > 0) ? v + 12 : 128;
  }

  function update() {
    if (!wrapper) return;
    if (!mq.matches) { wrapper.style.top = ''; return; }
    var top = Math.min(headerOffset(), window.innerHeight - wrapper.offsetHeight - BUFFER);
    wrapper.style.top = Math.round(top) + 'px';
  }

  function init() {
    var container = document.querySelector('.product-template[data-layout="layout-2"] .sf-prod__container');
    if (!container) return;
    var column = container.children[1];
    wrapper = column && column.querySelector('.sf-prod__info-wrapper');
    if (!wrapper) return;

    update();
    window.addEventListener('load', update);
    window.addEventListener('resize', update, { passive: true });
    setTimeout(update, 500);
    setTimeout(update, 1500);
    if (window.ResizeObserver) { new ResizeObserver(update).observe(wrapper); }
    if (mq.addEventListener) { mq.addEventListener('change', update); }

    var bus = window.MinimogEvents;
    var sub = bus && (bus.subscribe || bus.on);
    if (bus && typeof sub === 'function') {
      var pid = wrapper.closest('[data-product-id]');
      pid = pid && pid.getAttribute('data-product-id');
      if (pid) { sub.call(bus, pid + '__VARIANT_CHANGE', function () { setTimeout(update, 60); }); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
